
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { filter } from 'lodash';
import {
  Table,
  Avatar,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  TablePagination,CircularProgress,
  Box,
  Link,
  Checkbox,
  selectClasses,
} from '@mui/material';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserListToolbar } from '../../sections/@dashboard/user';
import Iconify from 'src/components/Iconify';
import client from 'src/api/clients';
import { getColor } from 'src/utils/color';
import DeviceAlert from './DeviceAlert';
import DeviceMoreMenu from './DeviceMoreMenu';
import DeviceListToolbar from './DeviceListToolbar';
import DeviceListHead from './DeviceListHead';
import DeviceDrawDialog from './DeviceDrawDialog';
import Switch from '@mui/material/Switch';
import useEnhancedEffect from '@mui/material/utils/useEnhancedEffect';
import ModalTemplate from './Modal';
import { getServerList ,getTimezoneList } from 'src/api/analytics';
import { updateStatus } from 'src/api/devices';
import { setCamlytics } from "src/api/devices";




import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { jsonToFormData } from "src/utils/config";

const TABLE_HEAD = [
  { id: 'name', label: 'S No', alignRight: false,tag:'' },
  { id: 'cameraId', label: 'Camera Id', alignRight: false,tag:'deviceid' },
  { id: 'clientName', label: 'Client name', alignRight: false,tag:'displayname' },
  { id: 'Location', label: 'Location', alignRight: false,tag:'Location' },
  { id: 'cameraName', label: 'Camera Name', alignRight: false,tag:'devicename' },
  { id: 'category', label: 'Category', alignRight: false,tag:'Category' },
  { id: 'timeZone', label: 'Time Zone', alignRight: false,tag:'TimezoneId' },
  { id: 'archives', label: 'Archives', alignRight: false,tag:'IsActive' },
  { id: 'speaker', label: 'Speaker', alignRight: false,tag:'HaveSpeaker' },
  { id: 'status', label: 'Status', alignRight: false,tag:'Status' },
  { id: 'camlytics', label: 'Analytics', alignRight: false,tag:'CamlyticsStatus' },
  { id: 'ftp', label: 'FTP', alignRight: false,tag:'IsFtp' },
  { id: 'actions', label: '', alignRight: true,tag:'' },
];

// const TABLE_HEAD = [
//     { id: 'name', label: 'S No', alignRight: false },
//     { id: 'role', label: 'Camera Name', alignRight: false },
//     { id: 'company', label: 'Camera ID', alignRight: false },    
//     { id: 'cameras', label: 'Client', alignRight: false },
//     { id: 'status', label: 'Status', alignRight: false },
//     { id: 'archivestatus',label:'Is Need Archive',alignRight:false},
//     { id: 'cameratype',label:'Camera Type',alignRight:false},
//     { id: 'category',label:'Category',alignRight:false},
//     { id: '',label:'',alignRight:true},
//   ]; 

  // const TABLE_HEAD = [
  //   { id: '', label: 'S No', alignRight: false },
  //   { id: '', label: 'Camera ID', alignRight: false },
  //   { id: '', label: 'Client name', alignRight: false },
  //   { id: '', label: 'Camera Name', alignRight: false },
  //   // { id: '', label: 'Local camera name', alignRight: false },f
  //   { id: '', label: 'Category', alignRight: false },
  //   { id: '', label: 'Time Zone', alignRight: false },
  //   { id: '', label: 'Archives', alignRight: false },
  //   // { id: '', label: 'Camera Type', alignRight: false },
  //   { id: '', label: 'Speaker', alignRight: false },
  //   { id: '', label: 'Status', alignRight: false },
  //   { id: "", label: "Camlytics", alignRight: false },
  //   { id: "", label: "FTP", alignRight: false },
  //   { id: '',label:'',alignRight:true},
  // ];

  // ----------------------------------------------------------------------
  
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  
  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  
export default function DeviceList({clientInfo,totalData,total, handleDialog, reloadClientsData,getClientid,updateClientDevices,handleMoremenu,selectedClient,onClientChange ,handleReloadPage,handleDisplay,setTotalData,timezoneDetails,apiResponse,isReseller,removeDeviceFromState,environmentType,onEnvironmentTypeChange}) {
  
      const [swich, setSwitch] = useState(false);
      const [disableMore,setMoreDisable] = useState(true);

      const [visibleCount, setVisibleCount] = useState(60);
      const [isFetchingMore, setIsFetchingMore] = useState(false);


      // const [timezoneDetails,setTimezone] = useState([]);
      // useEffect(() => {
      //   // console.log("Server ");
      //   getTimezoneList((response) => {
      //     if (response.status === 200) {
      //       // console.log("Time Zone ", response.data);
      //       setTimezone(response.data)    
      //     }
      //   });
      // }, []);

      const handleSwitch =(uid)=>{
        // console.log(uid)
      }

      useEffect(()=>{
          // console.log(swich)
      },[swich])

      const [page, setPage] = useState(0);

      const [order, setOrder] = useState('asc');

      const [selected, setSelected] = useState([]);

      const [orderBy, setOrderBy] = useState('name');

      const [filterName, setFilterName] = useState('');
      const [selectedLocationIds, setSelectedLocationIds] = useState([]);

      const [rowsPerPage, setRowsPerPage] = useState(100);

      const [loadingRows, setLoadingRows] = useState({});

      const [camalyticsSettings,setCamalayticsSettings] = useState([{CameraId:0,CamalyticsStatus:0,IsFtp:0}])

      const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
      };


      function applySortFilter(array, comparator, query) {
        const sortCol = TABLE_HEAD.filter(val=>val.id === orderBy)
        let key = sortCol.length>0 ? sortCol[0].tag : ""
        let sortedData =[]
        let stabilizedThis=[];

        if (key === "TimezoneId") {
          sortedData = [...array].sort((a, b) => {
            const timezoneA = timezoneDetails && timezoneDetails.find(timezone => timezone.Id === a.TimezoneId)?.TimeZone || '';
            const timezoneB = timezoneDetails && timezoneDetails.find(timezone => timezone.Id === b.TimezoneId)?.TimeZone || '';
      
            if (order === "asc") {
              return timezoneA.localeCompare(timezoneB);
            } else if (order === "desc") {
              return timezoneB.localeCompare(timezoneA);
            }
            return 0;
          });
        } else if(key){
          sortedData = [...array].sort((a, b) => {
              // if (a[key] < b[key]) return -1;
              // if (a[key] > b[key]) return 1;
              if (order === "asc") {
                  if (a[key] < b[key]) return -1;
                  if (a[key] > b[key]) return 1;
                } else if (order === "desc") {
                  if (a[key] > b[key]) return -1;
                  if (a[key] < b[key]) return 1;
                }
                return 0;
            });
      }       
      
      stabilizedThis = sortedData.map((el, index) => [el, index]);
      
      if(key==""){
          stabilizedThis = array.map((el, index) => [el, index]);
          stabilizedThis.sort((a, b) => {
              const order = comparator(a[0], b[0]);
              if (order !== 0) return order;
              return a[1] - b[1];
          });
      }
     
      if (query) {
        return filter(array, (_user) => {
            return ['deviceid', 'devicename', 'displayname'].some((property) => {
              const value = _user[property];
              if (typeof value === 'string') {
                return value.toLowerCase().includes(query.toLowerCase());
              } else if (typeof value === 'number' && !isNaN(parseFloat(query))) {
                return value.toString().startsWith(query);
              }
              return false;
            });
          });
      }
      return stabilizedThis.map((el) => el[0]);
      }

      const [clients, setClient] = useState(total)

      const [deviceId,setDeviceId]=useState([])

      const [clientId,setClientid] = useState([])

      const [loading,setLoading] = useState(false)
      const [isUserNotFound,setUserNotFound] = useState(false)
      

      useEffect( () =>{
        setClient(total)
        console.log(totalData)
        setVisibleCount(60)
       
        if(total.length > 0){
          setLoading(true)
          setUserNotFound(true)
        }
        else{
          setLoading(false)
          //if(selected)
        }
        const initialLoadingRows = total.reduce((acc, row) => ({
          ...acc,
          [row.deviceid]: { camlytics: false, ftp: false },
        }), {});
        setLoadingRows(initialLoadingRows);

      } 
       , [total])



      const handleClick = (event, name,id,clientid) => {
       
        const selectedIndex = selected.indexOf(name);
        const selectedIdIndex=deviceId.indexOf(id);
        
        let newSelected = [];
        let selectedId=[]; // to pass id's to archivetimings/montimings
        if (selectedIdIndex === -1) // device selection
        {
          selectedId=selectedId.concat(deviceId,id)
          if(clientid){
            // setClientid((prev) => 
            //   prev.includes(clientid) ? prev : [...prev, clientid]
            // );
            setClientid((prev) => {
              const existingIndex = prev.findIndex(item => item.clientId === clientid && item.deviceId === id);
              if (existingIndex === -1) {
                  return [...prev, { clientId: clientid, deviceId: id }];
              }
              return prev; 
          });
          }
        } 
        else if (selectedIdIndex === 0) // device removal
        {
          selectedId=selectedId.concat(deviceId.slice(1))
          // setClientid((prev) => 
          //   prev.includes(clientid) ? prev.filter(id => id !== clientid) : [...prev, clientid]
          // );
          setClientid((prev) => {
            return prev.filter(item => !(item.deviceId === id));
        });
        } 
        else if (selectedIdIndex === selected.length - 1) 
        {
          selectedId=selectedId.concat(deviceId.slice(0,-1))
          // console.log(clientId.includes(clientid))
          // setClientid((prev) => 
          //   prev.includes(clientid) ? prev.filter(id => id !== clientid) : [...prev, clientid]
          // );
          setClientid((prev) => {
            return prev.filter(item => !(item.deviceId === id));
        });
        } 
        else if (selectedIdIndex > 0) 
        {
          selectedId=selectedId.concat(deviceId.slice(0,selectedIdIndex),deviceId.slice(selectedIdIndex + 1))
          // setClientid((prev) => 
          //   prev.includes(clientid) ? prev.filter(id => id !== clientid) : [...prev, clientid]
          // );
          setClientid((prev) => {
            return prev.filter(item => !(item.deviceId === id));
          });
        }
        setSelected(selectedId);
        setDeviceId(selectedId)
      };


      const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
    
      const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
      };
    
      const handleFilterByName = (event) => {
        
        const pattern=event.target.value;
        setFilterName(pattern);
      };
    
      const locationFilteredClients = useMemo(() => {
        if (!selectedLocationIds.length) {
          return clients;
        }

        const selectedLocationIdSet = new Set(selectedLocationIds.map((locationId) => Number(locationId)));
        return clients.filter((row) => selectedLocationIdSet.has(Number(row.clientid)));
      }, [clients, selectedLocationIds]);

      const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - locationFilteredClients.length) : 0;
      //const emptyRows = clients.length
      
      const filteredUsers = applySortFilter(locationFilteredClients, getComparator(order, orderBy), filterName);
      const groupedFilteredUsers = useMemo(() => {
        if (selectedClient.length <= 1) {
          return filteredUsers;
        }

        const selectedClientOrder = Array.from(
          new Set(
            (selectedClient || [])
              .map((clientItem) =>
                String(clientItem?.displayname || '')
                  .trim()
                  .replace(/\s+/g, ' ')
                  .toLowerCase()
              )
              .filter(Boolean)
          )
        );

        return [...filteredUsers].sort((a, b) => {
          const clientNameA = String(a?.displayname || '').trim().toLowerCase();
          const clientNameB = String(b?.displayname || '').trim().toLowerCase();
          const clientIndexA = selectedClientOrder.indexOf(clientNameA);
          const clientIndexB = selectedClientOrder.indexOf(clientNameB);

          if (clientIndexA !== clientIndexB) {
            return clientIndexA - clientIndexB;
          }

          return String(a?.deviceid || '').localeCompare(String(b?.deviceid || ''));
        });
      }, [filteredUsers, selectedClient]);

      const displayedRows = groupedFilteredUsers.slice(0, visibleCount);
      const isTableSyncing = apiResponse && clients.length !== total.length;

      console.log("apiResponse",apiResponse)
      console.log("clients.length !== total.length",clients.length ,total.length)

      useEffect(() => {
        setPage(0);
      }, [selectedLocationIds, filterName]);

      const handleScroll = useCallback((event) => {
        const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;

        if (isFetchingMore || visibleCount >= groupedFilteredUsers.length) {
          return;
        }

        if (scrollHeight - scrollTop - clientHeight <= 120) {
          setIsFetchingMore(true);
          setVisibleCount((prevVisibleCount) => Math.min(prevVisibleCount + 60, groupedFilteredUsers.length));
        }
      }, [groupedFilteredUsers.length, isFetchingMore, visibleCount]);

      useEffect(() => {
        if (isFetchingMore) {
          setIsFetchingMore(false);
        }
      }, [isFetchingMore, visibleCount]);


      //const isUserNotFound = filteredUsers.length === 0;
      
      
      const [fillDevices, setFillDevices] = useState({
        isLoad: false,
        all: [],
        active: [],
        inActive: [],
        lastId: null
      })

    const [ confirmalert, setAlert ] = useState({
        title: '',
        content: '',
        open: false,
        id: null,
        status: null
    })

    const handleAlertClose = () => setAlert({...confirmalert, open:false})

    const handleAlertOpen = (event,id, status) => {
     // event.stopPropagation()
      //console.log(id)
        if (status === 'status' && Number(id.Status) === 0){
          //handleStatus(id.ID, 1)
          let content = 'Are you sure want to Active this record?'
          let btn = 'Yes, active record!'
          let upStatus = 1
          setAlert({
              title: btn,
              content: content,
              open: true,
              id: id.deviceid,
              status: upStatus
          })
        }
        else {
          // let title = status === 'status' ? 'Are you sure?' : 'Are you sure?'
          let content = status === 'status' ? 'Are you sure want to inactive this record?': 'Are you sure want to delete this record permanently?'
          let btn = status === 'status' ? "Yes, inactive record!": "Yes, delete record!"
          let upStatus = status === 'delete' ? 2 : 0
          setAlert({
              title: btn,
              content: content,
              open: true,
              id: id.deviceid,
              status: upStatus
          })
        }        
    }

    const handleStatus = (id, status) => {
     
        let body={deviceid:id,Status:status}
        
        updateStatus(body,(response)=>{
          if (response.status === 200) {
            handleReloadPage()
            handleAlertClose()
          }
        })
        
        
        
        // if (status === 2)
        //   client.deleteClient(id, (response) => {
        //     if (response.status === 200) {
              
        //       // console.log('Delete', response.data)
        //       reloadClientsData()
        //       handleAlertClose() // close confim box
        //     }
        //   })
        // else
        //   client.updateSataus(id, status, (response) => {
        //     if (response.status === 200) {
        //       reloadClientsData() //reload data
        //       // console.log(response.data)
        //       handleAlertClose() // close confim box
        //     }
        //   })
        

        // const update_status = status === 'delete' ? 2 : status === 'status' ? 2
        // let body = { Id: id }
        // if (status !== 2) {
        //     body.Status = status            
        //     updateStatus(body)
        // } else 
        //     deleteRecord(body)

        // handleAlertClose()
        // isReloadData(true)
    }

    const [chkStatus,setChkStatus]=useState(true)

    const handleSelectAll = (event)=> {
      
     
      if (chkStatus) {
        const pageDeviceIds = filteredUsers
                              //.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).
                              .map((client) => client.deviceid);
        
        deviceId.length > 0 ? setDeviceId([...new Set([...pageDeviceIds, ...deviceId])]) : setDeviceId(pageDeviceIds);
        //setDeviceId(pageDeviceIds);         
        setChkStatus(false)   
        
        const pageclientIds = filteredUsers.map((client) => ({ clientId: client.clientid, deviceId: client.deviceid }));
        setClientid((prev) => {
          const newClientIds = [...prev, ...pageclientIds];
          return Array.from(new Set(newClientIds.map(JSON.stringify))).map(JSON.parse);
        });
        //console.log(pageclientIds)
      } 
      else {
        setDeviceId([]);
        setChkStatus(true) 
        setClientid([]);
      }
    }

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [deviceInfo,setDeviceInfo]=useState({})
    
    const handleRowClick = (rowInfo) =>{
      if(deviceId.length==0 || deviceId.length==1){
        setDeviceInfo(rowInfo)
        setIsModalOpen(true)
      }
    }

    const closeModal = () => {
      setIsModalOpen(false);
    }


    useEffect(()=>{

      // console.log("deviceId",deviceId.length);
      if(deviceId.length >=2){
        // console.log("hide")
        setMoreDisable(false)
  
      }
      else{
      setMoreDisable(true)
  
      }
    })

    useEffect(()=>{
      console.log(camalyticsSettings)
    },[camalyticsSettings])

    const handleSwitchChange = (row) => {
  const updatedCamlyticsStatus = row.CamlyticsStatus === 0 ? 1 : 0;

  const updatedRow = {
    ...row,
    CamlyticsStatus: updatedCamlyticsStatus,
    IsFtp: row.IsFtp,
  };

  
  setClient((prevClients) =>
    prevClients.map((client) =>
      client.deviceid === row.deviceid ? updatedRow : client
    )
  );

 
  setLoadingRows((prev) => ({
    ...prev,
    [row.deviceid]: { ...prev[row.deviceid], camlytics: true },
  }));

  const data = {
    CameraId: row.deviceid,
    Status: updatedCamlyticsStatus,
    IsFtp: row.IsFtp,
  };

  setCamlytics(jsonToFormData(data), (response) => {
    if (response.status === 200) {
      // Update parent devices state
      updateClientDevices((prevDevices) => {
        const updatedAll = prevDevices.all.map((item) =>
          item.deviceid === row.deviceid ? updatedRow : item
        );
        const updatedActive = prevDevices.active.map((item) =>
          item.deviceid === row.deviceid ? updatedRow : item
        );
        const updatedInActive = prevDevices.inActive.map((item) =>
          item.deviceid === row.deviceid ? updatedRow : item
        );

        return {
          ...prevDevices,
          all: updatedAll,
          active: updatedActive,
          inActive: updatedInActive,
        };
      });

      // Update totalData to keep it in sync
      setTotalData((prevTotalData) =>
        prevTotalData.map((item) =>
          item.deviceid === row.deviceid ? updatedRow : item
        )
      );
    } else {
      // Revert local clients state on failure
      setClient((prevClients) =>
        prevClients.map((client) =>
          client.deviceid === row.deviceid ? row : client
        )
      );
      console.error("Failed to update CamlyticsStatus");
    }
    setLoadingRows((prev) => ({
      ...prev,
      [row.deviceid]: { ...prev[row.deviceid], camlytics: false },
    }));
  });
};

const handleSwitchFTPChange = (row) => {
  const updatedIsFtp = row.IsFtp === 0 ? 1 : 0;

  const updatedRow = {
    ...row,
    CamlyticsStatus: row.CamlyticsStatus,
    IsFtp: updatedIsFtp,
  };

  // Update local clients state for immediate UI update
  setClient((prevClients) =>
    prevClients.map((client) =>
      client.deviceid === row.deviceid ? updatedRow : client
    )
  );

  setLoadingRows((prev) => ({
    ...prev,
    [row.deviceid]: { ...prev[row.deviceid], ftp: true },
  }));
  const data = {
    CameraId: row.deviceid,
    Status: row.CamlyticsStatus,
    IsFtp: updatedIsFtp,
  };

  setCamlytics(jsonToFormData(data), (response) => {
    if (response.status === 200) {
      // Update parent devices state
      updateClientDevices((prevDevices) => {
        const updatedAll = prevDevices.all.map((item) =>
          item.deviceid === row.deviceid ? updatedRow : item
        );
        const updatedActive = prevDevices.active.map((item) =>
          item.deviceid === row.deviceid ? updatedRow : item
        );
        const updatedInActive = prevDevices.inActive.map((item) =>
          item.deviceid === row.deviceid ? updatedRow : item
        );

        return {
          ...prevDevices,
          all: updatedAll,
          active: updatedActive,
          inActive: updatedInActive,
        };
      });

      // Update totalData to keep it in sync
      setTotalData((prevTotalData) =>
        prevTotalData.map((item) =>
          item.deviceid === row.deviceid ? updatedRow : item
        )
      );
    } else {
      // Revert local clients state on failure
      setClient((prevClients) =>
        prevClients.map((client) =>
          client.deviceid === row.deviceid ? row : client
        )
      );
      console.error("Failed to update IsFtp");
    }
    setLoadingRows((prev) => ({
      ...prev,
      [row.deviceid]: { ...prev[row.deviceid], ftp: false },
    }));
  });
};

    return (
      <>
        <Box>       
              <DeviceAlert
                alert={confirmalert.open}
                handleAlertClose={handleAlertClose}
                title={confirmalert.title}
                content={confirmalert.content}
                id={confirmalert.id}
                status={confirmalert.status}
                handleStatus={handleStatus}
                />

            
            <DeviceListToolbar handleReloadPage={handleReloadPage} selectedClient={selectedClient} onClientChange={onClientChange} totalData={totalData} numSelected={deviceId.length} filterName={filterName} onFilterName={handleFilterByName}  reloadClientsData={reloadClientsData} clientInfo={clientInfo} getClientid={getClientid} deviceInfo={deviceId} totalInfo={total} handleDisplay={handleDisplay} clientVal={clientId} selectedLocationIds={selectedLocationIds} onLocationChange={setSelectedLocationIds} environmentType={environmentType} onEnvironmentTypeChange={onEnvironmentTypeChange}/>
            <DeviceDrawDialog/>
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800, maxHeight: 900 }} onScroll={handleScroll}>
                <Table stickyHeader>
                  <DeviceListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={clients.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAll}
                  />
                  {!apiResponse || isTableSyncing ? (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={13} sx={{ py: 3 }}>
                          <CircularProgress />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  ) : locationFilteredClients.length === 0 ? (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={13} sx={{ py: 6 }}>
                          <Box
                            sx={{
                              width: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                              No data
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  ) : filteredUsers.length === 0 ? (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={13} sx={{ py: 6 }}>
                          <Box
                            sx={{
                              width: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                              No data
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  ) : (
                    <TableBody>
                      {displayedRows.map((row, inc) => {
                        const { devicename, deviceid, Location, displayname, Status, IsActive, Category, TimezoneId, HaveSpeaker, CamlyticsStatus, IsFtp, clientid } = row;
                        const isItemSelected = deviceId.indexOf(deviceid) !== -1;

                        return (
                          <TableRow
                            hover
                            key={deviceid}
                            tabIndex={-1}
                            role="checkbox"
                            selected={isItemSelected}
                            onClick={() => handleRowClick(row)}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                onChange={(event) => {
                                  event.stopPropagation();
                                  handleClick(event, devicename, deviceid, clientid);
                                }}
                              />
                            </TableCell>
                            <TableCell align="left">{inc + 1}</TableCell>
                            <TableCell align="left">{deviceid}</TableCell>
                            <TableCell align="left">
                              <Typography>{displayname}</Typography>
                            </TableCell>
                            <TableCell align="left">{Location}</TableCell>
                            <TableCell align="left">{devicename}</TableCell>
                            <TableCell align="left">
                              {Category === 0 ? 'Not Assigned' :
                                Category === 1 ? 'Category 1' :
                                  Category === 2 ? 'Category 2' :
                                    Category === 3 ? 'Category 3' : 'Not Assigned'}
                            </TableCell>
                            <TableCell align="left">
                              {timezoneDetails && timezoneDetails.find((timezone) => timezone.Id === TimezoneId)
                                ? timezoneDetails.find((timezone) => timezone.Id === TimezoneId).TimeZone
                                : 'Not selected'}
                            </TableCell>
                            <TableCell align="left">
                              <Label variant="ghost" color={IsActive === 1 ? 'success' : 'error'}>
                                {IsActive === 1 ? 'Active' : 'In Active'}
                              </Label>
                            </TableCell>
                            <TableCell>
                              <Label variant="ghost" color={HaveSpeaker === 1 ? 'success' : 'error'}>
                                {HaveSpeaker === 1 ? 'Yes' : 'No'}
                              </Label>
                            </TableCell>
                            <TableCell>
                              <Label variant="ghost" color={Status === 1 ? 'success' : 'error'}>
                                {Status === 1 ? 'Active' : 'In Active'}
                              </Label>
                            </TableCell>
                            <TableCell>
                              {loadingRows[row.deviceid]?.camlytics ? (
                                <CircularProgress size={22} />
                              ) : (
                                <Switch
                                  checked={CamlyticsStatus === 1}
                                  onChange={() => handleSwitchChange(row)}
                                  color={CamlyticsStatus ? 'success' : 'error'}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              {loadingRows[row.deviceid]?.ftp ? (
                                <CircularProgress size={22} />
                              ) : (
                                <Switch
                                  checked={IsFtp === 1}
                                  onChange={() => handleSwitchFTPChange(row)}
                                  color={IsFtp ? 'success' : 'error'}
                                />
                              )}
                            </TableCell>
                            <TableCell align="right">
                              {disableMore && (
                                <DeviceMoreMenu
                                  handleAlertOpen={(event, id, status) => handleAlertOpen(event, id, status)}
                                  handleDialog={handleDialog}
                                  handleMoremenu={handleMoremenu}
                                  removeDeviceFromState={removeDeviceFromState}
                                  row={row}
                                />
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                </Table>
              </TableContainer>

                        {/* {!loading &&  (
                          <TableBody>
                            <TableRow>
                                <TableCell align="center" colSpan={12} sx={{ py: 3 }}>                                  
                                    <Typography variant="body1" align="center" sx={{ fontWeight: 'bold' }}>
                                      No data
                                    </Typography>
                                </TableCell>
                            </TableRow>
                          </TableBody>
                            
                        )} */}
            </Scrollbar>

            {/* <TablePagination
                rowsPerPageOptions={[100, 300, 500]}
                component="div"
                count={clients.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{ backgroundColor: (theme) => theme.palette.background.neutral }}
            /> */}
        </Box>
       
      </>
    )
}
